import React from 'react';
import { Text, Timestamp } from './styled';
function MessageWithTimestamp(_ref) {
  var id = _ref.id,
    message = _ref.message,
    timestamp = _ref.timestamp;
  return /*#__PURE__*/React.createElement(Text, {
    id: id
  }, message, /*#__PURE__*/React.createElement(Timestamp, null, timestamp));
}
export default MessageWithTimestamp;